import type { InputHTMLAttributes } from 'react';

interface FieldProps extends InputHTMLAttributes<HTMLInputElement> {
  label: string;
  name: string;
  error?: string;
  hint?: string;
}

/** A labelled input with its error message wired up for screen readers. */
export function Field({ label, name, error, hint, id, ...input }: FieldProps) {
  const inputId = id ?? `f-${name}`;
  const describedBy = [error && `${inputId}-error`, hint && `${inputId}-hint`].filter(Boolean).join(' ');
  return (
    <div className={error ? 'field field--error' : 'field'}>
      <label htmlFor={inputId}>{label}</label>
      <input
        id={inputId}
        name={name}
        aria-invalid={error ? true : undefined}
        aria-describedby={describedBy || undefined}
        {...input}
      />
      {hint && !error && (
        <small id={`${inputId}-hint`} className="field__hint">
          {hint}
        </small>
      )}
      {error && (
        <small id={`${inputId}-error`} className="field__error">
          {error}
        </small>
      )}
    </div>
  );
}
